module.exports = __webpack_public_path__ + "static/img/04.0d2dd29.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/03/3/04.png
// module id = xh1T
// module chunks = 2